<button [ngClass]="'cb-button-'+type" [class.disabled]="disabled" [class.cb-large-icon-btn]="large" (click)="click($event)">
  <cb-icon [name]="icon"></cb-icon>
</button>
